// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"b050c286","515":"0528b1f9","751":"6e4d49b0"}[chunkId] + ".chunk.css";
};